import React from "react";
import PropTypes from "prop-types";
import TopBar from "../components/common/topBar/TopBar";
import NavigationBar from "../components/common/navigationBar/NavigationBar";
import Footer from "../components/common/footer/Footer";
import styles from "./DefaultLayout.module.scss";
import Welcome from "../pages/welcome/Welcome";

const DefaultLayout = ({children, topbar, navigation, menu, footer}) => {
  return (
    <div className="layout-section">
      {topbar}
      {navigation}
      <div className={styles.siteContainer}>
        <div className={styles.siteSubCont}>
          <main style={{minHeight: "400px"}}>{children}</main>
        </div>
      </div>
      {footer}
    </div>
  );
};

DefaultLayout.propTypes = {
  topbar: PropTypes.element,
  navigation: PropTypes.element,
  footer: PropTypes.element
};

DefaultLayout.defaultProps = {
  topbar: <TopBar/>,
  navigation: <NavigationBar
    default={1}
    final={['/finished']}
    items={[
      {
        index: 1,
        label: <span>Welcome</span>,
        plainLabel: 'Welcome',
        url: '/welcome',
        display: true,
      },
      {
        index: 2,
        label: <span>Details of the<br/>person who<br/>has died</span>,
        plainLabel: 'Details of the person who has died',
        url: '/deceased-details',
        display: true,
      },
      {
        index: 3,
        label: <span>Your details</span>,
        plainLabel: 'Your details',
        url: '/your-details',
        otherUrls: ['match-result'],
        display: true,
      },
      {
        index: 4,
        label: <span>Confirm and<br/>notify</span>,
        plainLabel: 'Confirm and notify',
        url: '/confirm',
        display: true,
      },
      {
        index: 5,
        label: <span>Notification</span>,
        plainLabel: 'Notification',
        url: '/finished',
        display: true,
      }
    ]}/>,
  footer: <Footer/>
};

export default DefaultLayout;
